import React, { useState, useEffect, forwardRef, useImperativeHandle, useRef } from 'react'
import { Button, Container, Spinner, Table } from 'react-bootstrap';
import {
    DatatableWrapper,
    Filter,
    Pagination,
    PaginationOptions,
    TableBody,
    TableHeader
} from 'react-bs-datatable';
// import WhiteObjectApi from "../../api/WhiteObjectApi";
// import moment from 'moment';
import { formatDateTime, getUserDetails } from '../../utils/helper';
import solisPowerApi from '../../api/solisPowerApi';
import { ROUTES } from '../../constants/webRouting';
import { Link } from 'react-router-dom';
import SiteVisitModal from './SiteVisitModal';
import PERMISSIONS from '../../constants/permissions';
// import { useNavigate } from "react-router-dom";
// import { useLocation } from 'react-router-dom';

const RelatedSiteVisitHistory = (props) => {
    const userInfo = getUserDetails();
    const [body, setBody] = useState([]);
    // modal state
    const [modalShowSiteVisit, setModalShowSiteVisit] = useState(false);
    // visit data 
    const [visitData, setVisitData] = useState(null);
    useEffect(() => { console.log('visitData', visitData) }, [visitData]);
    async function init() {
        let userTrackings = await solisPowerApi.fetchUserTrackingByParentId(props.parent.id);
        //console.log('userTrackings', userTrackings);
        if (userTrackings && userTrackings?.length > 0) {
            setBody(userTrackings);
        } else {
            setBody([]);
        }
    }
    useEffect(() => {
        init();
    }, [props?.refreshSiteVisitList]);

    const edit = (visitData) => {
        setVisitData(visitData);
        setModalShowSiteVisit(true);
    }
    const submitSiteVisit = () => {
        setModalShowSiteVisit(false);
        init();
    };

    // const labels = {
    //     beforeSelect: " "
    // }

    const header = [
        { title: 'Check-In Date Time', prop: 'logindatetime', cell: (row) => (formatDateTime(row?.logindatetime)) },
        { title: 'Check-Out Date Time', prop: 'logoutdatetime', cell: (row) => (formatDateTime(row?.logoutdatetime)) },
        { title: 'Project Name', prop: 'project_name' },
        { title: 'Location', prop: 'location' },
        { title: 'Visit Status', prop: 'visit_status' },
        // { title: 'Assign User', prop: 'owner_id', cell: (row) => <Link to={`${ROUTES.USER.LIST}/${row.owner_id}`} state={row}> {row.owner_name} </Link> },
        {
            title: "Assigned Users",
            prop: "owner_ids",
            cell: (row) => (
                <div className="d-flex flex-wrap gap-1">
                    {row.owner_ids?.map((item, index) =>
                        item?.value && (
                            <Link
                                key={index}
                                to={`${ROUTES.USER.LIST}/${item.value}`}
                                state={row}
                                className="d-flex justify-content-center align-items-center px-2 py-1 rounded-pill shadow-sm text-decoration-none"
                                style={{
                                    background: "#f5f7fa",
                                    border: "1px solid #e0e0e0",
                                    transition: "0.2s",
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.background = "#eaf1ff")}
                                onMouseLeave={(e) => (e.currentTarget.style.background = "#f5f7fa")}
                            >
                                {/* <img
                                        src="https://www.w3schools.com/bootstrap4/img_avatar3.png"
                                        className="rounded-circle"
                                        style={{
                                          height: "30px",
                                          width: "30px",
                                          objectFit: "cover",
                                          border: "2px solid #007bff",
                                        }}
                                        alt=""
                                      /> */}
                                <span className="fw-semibold text-primary">{item.label}</span>
                            </Link>
                        )
                    )}
                </div>
            ),

            isFilterable: true,
        },
        { title: 'Remarks', prop: 'remarks' },
        // {
        //     title: 'IS Visit Completed', prop: 'is_completed',
        //     cell: (row) => (
        //         row.is_completed === true ? <i className="fa-regular fa-square-check" style={{ fontSize: "1.3rem", marginLeft: "19px" }}></i> : <i className="fa-regular fa-square" style={{ fontSize: "1.3rem", marginLeft: "19px" }}></i>
        //     )
        // },
        {
            title: "Actions",
            prop: "id",
            cell: (row) => (
                <>
                    {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_SITE_VISIT].some(permission => {
                        return userInfo?.permissions?.map(p => p.name).includes(permission);
                    }) && (
                            <Button
                                size="sm"
                                className="btn-custom"
                                onClick={() => edit(row)}
                            >
                                <i className="fa-regular fa-pen-to-square "></i>
                            </Button>
                        )
                    }
                </>
            ),
        },
    ];

    return (
        <>
            <DatatableWrapper
                body={body}
                headers={header}
                paginationOptionsProps={{
                    initialState: {
                        rowsPerPage: 5
                    }
                }}
            >
                <Table striped className="related-list-table shadow rounded sm" responsive={true}>
                    <TableHeader classes={{ th: 'bg-custom text-white' }} />
                    {(body && Array.isArray(body)) ?
                        <TableBody />
                        :
                        <tbody className="">
                            <tr>
                                <td colSpan={100} align="center">
                                    <div>
                                        <Spinner />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    }
                </Table>
                <Pagination classes={{ buttonGroup: "btn-custom", button: "bg-custom border-white" }} />
            </DatatableWrapper>
            {modalShowSiteVisit && <SiteVisitModal
                show={modalShowSiteVisit}
                onHide={() => setModalShowSiteVisit(false)}
                visitData={visitData}
                submitSiteVisit={submitSiteVisit}
            />}
        </>

    )
};

export default RelatedSiteVisitHistory
